<template>
  <section class="quote-refer-info">
    <div class="box">
      <h2>Client Info</h2>
      <div class="table mg-b-10">
        <div class="tr">
          <span>Effective Date</span>
          <span>{{ formData.pcy_cmnt_date }}</span>
        </div>
        <div class="tr">
          <span>Period of Insurance</span>
          <span>{{ getAllOptionName21('period', formData.period_of_cvr) }}</span>
        </div>
        <div class="tr">
          <span>Policy End Date</span>
          <span>{{ formData.pcy_expry_date }}</span>
        </div>
      </div>
    </div>

    <div class="box">
      <h2>Policyholder Detail</h2>
      <div class="table">
        <div class="tr">
          <span>Title</span>
          <span>{{ getOptionName('titleOptions', formData.isrd_title) }}</span>
        </div>
        <div class="tr">
          <span>Occupation</span>
          <span>{{ formData.occ }}</span>
        </div>
        <div class="tr">
          <span>Last Name</span>
          <span>{{ formData.isrd_lst_nm }}</span>
        </div>
        <div class="tr">
          <span>First Name</span>
          <span>{{ formData.isrd_fst_nm }}</span>
        </div>
        <div class="tr">
          <span>Mobile Number</span>
          <span>{{ formData.mobile_no }}</span>
        </div>
        <div class="tr">
          <span>HKID Number</span>
          <span>{{ formData.id_no }}</span>
        </div>
        <!--        <div class="tr">-->
        <!--          <span>Email</span>-->
        <!--          <span>{{ formData.email }}</span>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="box">
      <span class="title">Proposed Location of Risk</span>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span>{{ formData.addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span>{{ formData.addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span>{{ formData.addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span>{{ formData.addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span>{{ formData.addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span>{{ getAreaName('district', formData.addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span>{{ getAreaName('area', formData.addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span>{{ getAreaName('region', formData.addr_region) }}</span>
        </div>
      </div>
    </div>
    <div
      class="box">
      <span class="title">Correspondence Address</span>
      <div
        class="table">
        <div class="tr">
          <span>Is your Correspondence Address same as Proposed Location of Risk?</span>
          <span>{{ getOptionName('yesOrNo', formData.is_addr_same_ind) }}</span>
        </div>
        <div class="tr">
          <span>Room</span>
          <span>{{ formData.cor_addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span>{{ formData.cor_addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span>{{ formData.cor_addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span>{{ formData.cor_addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span>{{ formData.cor_addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span>{{ getAreaName('district', formData.cor_addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span>{{ getAreaName('area', formData.cor_addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span>{{ getAreaName('region', formData.cor_addr_region) }}</span>
        </div>
      </div>
    </div>
    <div class="box">
      <h2>Domestic Helper’s Information</h2>
      <div class="table">
        <div class="tr">
          <span>Title</span>
          <span><span>{{ getOptionName('titleOptions', formData.domestic_title) }}</span></span>
        </div>
        <div class="tr">
          <span>Name</span>
          <span>{{ formData.full_name }}</span>
        </div>
        <div class="tr">
          <span>HKID/Passport Number</span>
          <span>{{ formData.domestic_id_no }}</span>
        </div>
        <div class="tr">
          <span>Position/Duties</span>
          <span>{{ getAllOptionName21('duties', formData.duty_id) }}</span>
        </div>
        <div class="tr">
          <span>Date of Birth</span>
          <span>{{ formData.domestic_dob_date }}</span>
        </div>
        <div class="tr">
          <span>Nationality</span>
          <!-- <span>{{ getAllOptionName21('nationality', formData.nationality_id) }}</span> -->
          <!-- <span>{{ nationalityInfo }}</span> -->
          <span>{{ getOptionName('', formData.nationality_id, nationalityOptions) }}</span>
        </div>
        <div class="tr">
          <span>Monthly Salary</span>
          <span>{{ getOptionName('', formData.monthly_salary, salaryOptions) }}</span>
        </div>
      </div>
    </div>
    <div class="box">
      <h2>Upload Document</h2>
      <div class="table">
        <div class="tr">
          <span>Policyholder HKID</span>
          <span
            class="file"
            @click="openFile(formData.id_type_pic.url)">{{ formData.id_type_pic? 'file': '' }}</span>
        </div>
        <div class="tr">
          <span>Domestic Helper HKID/ Passport</span>
          <span
            class="file"
            @click="openFile(formData.domestic_id_type_pic.url)">{{ formData.domestic_id_type_pic? 'file': '' }}</span>
        </div>
        <div
          v-for="(item, index) in formData.other_file"
          :key="index"
          class="tr">
          <span>Additional Documents</span>
          <span
            class="file"
            @click="openFile(item.url)">{{ item.url? 'file': '' }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'HousemaidQuoteReferInfo',
  mixins: [MixinOptions],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).add(Number(period_of_cvr)*10, 'months').format('YYYY-MM-DD')
        }
        // return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions21
    },
    isDoula() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        return doula
      }
      return others
    },
    nationalityInfo() {
      const { nationality_id } = this.formData
      const result = this.getOptionName('', nationality_id, this.nationalityOptions)
      return result
      // if(result) {
      //   return result
      // }
      // return this.getAllOptionName21('nationality', nationality_id)
    }
  },
  watch: {
    'formData.nationality_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.updateNationalityOptions(val)
        }
      }
    }
  },
  methods: {
    ...mapActions('common', ['updateNationalityOptions']),
    openFile(url) {
      if(!url) return
      window.open(url, '_blank')
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-refer-info {
  .box {
    margin-bottom: 15px;
  }
  .title {
    display: block;
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }
  .file {
    color: $blue;
    cursor: pointer;
  }
}
</style>
